import { useEffect } from "react";
import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Grid } from "@mui/material";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";
import { KEYBOARD_KEYS, EVENTS } from "const";
import { eventsEmitter } from "utils/events";

function CashierMismatchDialog({ open, onClose, onCloseShift, cashierName }) {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === KEYBOARD_KEYS.ENTER) {
        event.preventDefault();
        onCloseShift?.();
      } else if (event.key === KEYBOARD_KEYS.ESCAPE) {
        event.preventDefault();
        onClose?.();
      }
    };

    const unsubscribeFn = eventsEmitter.on(EVENTS.KEY_DOWN, handleKeyDown);
    return unsubscribeFn;
  }, [open, onClose, onCloseShift]);

  if (!open) return null;

  return (
    <div className={styles.popUp}>
      <Grid
        container
        className={styles.billContentWrapper}
        onClick={(e) => {
          e.stopPropagation();
        }}
        rowSpacing={1.5}
        style={{ marginTop: "24px" }}
      >
        <Grid item xs={12} pt={0} className={styles.header}>
          <h3>Shift Already Started</h3>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </Grid>
        <Grid item xs={12} className={styles.paragraph}>
          <span>
            This shift was started by another cashier ({cashierName}). Please close the shift before logging in with
            your account.
          </span>
        </Grid>
        <Grid item xs={12} className={styles.footSec}>
          <ButtonGray onClick={onClose}>No</ButtonGray>
          <ButtonRed onClick={onCloseShift}>Close Shift</ButtonRed>
        </Grid>
      </Grid>
    </div>
  );
}

export default CashierMismatchDialog;
